<template>
    <div id="addMaterial" class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enMaterialLibrary')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSub('ruleForm')"
            >
             {{$route.query.id ? '替换' : '保存'}}
           </el-button>
            </div>
         <div class="edit-from">
             <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
             <el-form-item label="素材名称：">
                    <el-input v-model="form.name" placeholder="请输入素材名称【1-50】" clearable></el-input>
             </el-form-item>
                <el-form-item label="素材分类：" prop="classifyId">
                 <el-select
                        v-model="form.classifyId"
                        clearable
                        placeholder="请选择素材分类"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
         </el-form-item>
             </el-form>
         </div>
           <div class="importTopic">
            <el-upload 
            accept="" drag  
            :limit="1"  
            :auto-upload="true" 
             :action="$config.baseUrl + '/admin/sys-file/upload'" 
              :headers="headers"
             :on-success="handleSuccess"
              ref="upload"  
              >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   请将文件拖拽到此区域上传，或<em>选择文件上传</em>
                </div>
               <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <div class="tips-text">
                <div class="title">上传说明</div>
                <p style="margin-top:17px">
                 视频格式支持:3gp、av、fiv、mp4、mpg、asf、wmv、mkv、mov、dat 等格式，文件大小不能超过2G。
                </p>
                <p>音频格式支持:mp3，m4a，wma，wav格式，文件大小不超过200M。</p>
                <p>文档格式支持:doc，docx，wps，ppt,pptx，pdf,himl，txt，xls，xsx格式，文件大小不超过300M。</p>
            </div>
        </div>
    </div>
</template>
<script>
import {materialAllClassify,editMaterial,deletMaterial} from "@/api/enterprise/index"  //素材库分类、新增/修改素材、素材详情
import debounce from '../../../utils/debounce.js' //防抖
export default {
    data () {
        return {
            businessInfo:{},
            loading:false,
            itemList:[],
            uploadParms:{},
            form:{
                classifyId:'',
                name:'',
            },
            rules:{
              classifyId: [{ required: true, message: '请选择素材库分类', trigger: 'change' }],
            }
        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getLibClass()
        this.getCertDetail()
            let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
         // 素材详情
        getCertDetail(){
             deletMaterial({id:this.$route.query.id},'get')
            .then(res =>{
               this.form = {
                name:res.data.name,
                classifyId:res.data.classifyId,
                }
            })
            .catch(err =>{})
        },
             // 文件上传成功
        handleSuccess(res, file){
           if(res.code == 0){
            this.uploadParms = res.data
           }
        },
            // 获取分类
        getLibClass(){
            this.itemList = []
             materialAllClassify({
                name:'',
                businessId:this.businessInfo.id
             })
            .then(res => {
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 保存
        openSub(formName){
         let params = {},
             method = "post"
         if(!this.$route.query.id) params = {...this.form,...this.uploadParms,businessId:this.businessInfo.id},method = "post";
         if(this.$route.query.id) params = {...this.form,...this.uploadParms,id:this.$route.query.id,businessId:this.businessInfo.id}, method = "put";
         if(!this.uploadParms.fileId) return this.$util.Notifi('请上传素材','error','fa-exclamation-circle');
          this.$refs[formName].validate((valid) => {  
                     if(valid){
                         //防抖提交
                    debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                     }
             })
        },
              commentBness(params,method){
               this.loading = true
                editMaterial(params,method)
                    .then(res => {
                        if(res.code == 0){
                        this.loading = false
                        if(!this.$route.query.id) this.$message.success('新增成功');
                            setTimeout(() => {
                        this.$router.push({
                        name:'enMaterialLibrary',
                        query:{
                        }
                        })
                            }, 100);
                        }else{
                            this.loading = false
                        this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                        this.loading = false
                    })
        },
    },
}
</script>
<style lang="scss" scoped>
#addMaterial{
    margin-bottom: 70px;
}
.importTopic{
    width: 100%;
    text-align: center;
    padding-top: 0px;
    box-sizing: border-box;
    .template-text{
        display: flex;
        align-items: center;
    justify-content: center;
    color: #7a8c99;
    font-size: 14px;
    cursor: pointer;
    padding-top: 20px;
.excel-icon{
        display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../../../assets/images/excel-deactivate.svg') center no-repeat;
}
    }
    .tips-text{
   background-color: #f2f9fe;
    padding: 25px 10px 30px 30px;
    margin: 50px 35px 24px;
    text-align: left;
    .title{
        font-size: 18px;
        color: #36aafd;
    line-height: 30px;
    font-weight: normal;
    font-stretch: normal;
    }
    p{
        font-size: 16px;
        line-height: 30px;
    letter-spacing: 0px;
    color: #666666;
    }
    }
}
   .edit-from{
         margin-bottom: 44px;
         .public-tit{
            width: 100%;
            margin-bottom: 20px;
         }
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
                    ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 140px;
    height: 140px;
    display: block;
  }
   .avatar1 {
    width: 130px;
    height: 50px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
  ::v-deep{
    .el-upload,.el-upload-dragger{
    background: none;
    border: none;
    height: auto;
   .icon-al-file-fill{
    font-size: 80px;
    color: #C0C4CC;
    margin: 0px 0 16px;
    }
    .el-button{
        margin-top: 30px;
    }
    }
    
 
}
</style>